import {
	FacilityMaintenanceVendor,
	Location,
	Model,
	Status
} from ".";

export default class FacilityMaintenanceWorkOrder extends Model {
	get singularNoun() {
		return "work order";
	}

	get mutations() {
		return {
			location: Location,
			statuses: Status,
			vendor: FacilityMaintenanceVendor
		};
	}

	get approved() {
		return this.$.status !== "Unapproved";
	}

	get completed() {
		return this.$.status === "Completed";
	}

	resource() {
		return "facility-maintenance/work-orders";
	}
}
